// Подписи и цвета статусов план/факта игр Planfix (спека §5)
export const STATUS_LABELS = {
  planned: 'Запланирована',
  held: 'Проведена',
  no_show: 'Не состоялась',
  cancelled: 'Отменена',
}

export const STATUS_OPTIONS = Object.entries(STATUS_LABELS).map(([value, text]) => ({ value, text }))

export const SOURCE_LABELS = {
  import: 'импорт',
  plan_file: 'файл расписания',
  planfix: 'вне плана',
}

export const SOURCE_OPTIONS = Object.entries(SOURCE_LABELS).map(([value, text]) => ({ value, text: text.charAt(0).toUpperCase() + text.slice(1) }))

export const statusVariant = game => {
  if (!game) return 'secondary'
  if (game.status === 'cancelled') return game.planfix_task_id ? 'danger' : 'secondary'
  return { planned: 'primary', held: 'success', no_show: 'warning' }[game.status] || 'secondary'
}

export const statusLabel = game => {
  if (!game) return '—'
  if (game.status === 'cancelled' && !game.planfix_task_id) return 'Не создана в ПФ'
  return STATUS_LABELS[game.status] || game.status
}

// расписание игр — московское, бэкенд отдаёт ISO с +03:00
export const formatTime = iso => {
  if (!iso) return '—'
  return new Date(iso).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow' })
}

// расписание игр — московское, бэкенд отдаёт ISO с +03:00
export const formatDateTime = iso => {
  if (!iso) return '—'
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Moscow',
  })
}

export const formatDay = ymd => {
  if (!ymd) return '—'
  return new Date(`${ymd}T00:00:00`).toLocaleDateString('ru-RU', { weekday: 'short', day: '2-digit', month: '2-digit' })
}

export const formatConversion = value => {
  if (value === null || value === undefined) return '—'
  return `${Math.round(value * 100)} %`
}
